import { IAppInitInfo, Template, ICustomVariables } from '../types'
import { MutationTree } from 'vuex'
import { State } from './state'

export enum MutationTypes {
  ADD_BUILDER = 'SET_BUILDER',
  ADD_PARENT_APP = 'SET_PARENT_APP',
  UPDATE_TEMPLATE = 'UPDATE_TEMPLATE',
  UPDATE_AUTH_INFO = 'UPDATE_AUTH_INFO',
  UPDATE_TOKEN = 'UPDATE_TOKEN',
  UPDATE_RETRY_COUNT = 'UPDATE_RETRY_COUNT',
  UPDATE_CUSTOM_VALUES = 'UPDATE_CUSTOM_VALUES',
}

export type Mutations<S = State> = {
  [MutationTypes.UPDATE_RETRY_COUNT](state: S, payload: number): void
  [MutationTypes.ADD_BUILDER](state: S, payload: {}): void
  [MutationTypes.ADD_PARENT_APP](state: S, payload: {}): void
  [MutationTypes.UPDATE_TEMPLATE](state: S, payload: Template): void
  [MutationTypes.UPDATE_AUTH_INFO](state: S, payload: IAppInitInfo): void
  [MutationTypes.UPDATE_TOKEN](state: S, payload: string): void
  [MutationTypes.UPDATE_CUSTOM_VALUES](
    state: S,
    payload: ICustomVariables
  ): void
}

export const mutations: MutationTree<State> & Mutations = {
  [MutationTypes.ADD_BUILDER](state: State, payload) {
    state.builderState = payload
  },
  [MutationTypes.ADD_PARENT_APP](state: State, payload) {
    state.iframeState = payload
  },
  [MutationTypes.UPDATE_TEMPLATE](state: State, payload) {
    state.templateData = payload
  },
  [MutationTypes.UPDATE_TEMPLATE](state: State, payload) {
    state.templateData = payload
  },
  [MutationTypes.UPDATE_AUTH_INFO](state: State, payload) {
    const {
      userId,
      apiKey,
      timeZone,
      tokenId,
      email,
      userName,
      userPermissions,
      enableAssignToData,
      companyId,
      locationId,
      emailId,
      parentBaseUrl,
    } = payload
    state.userId = userId
    state.apiKey = apiKey
    state.timeZone = timeZone
    state.tokenId = tokenId
    state.userEmail = email
    state.userName = userName
    state.userPermissions = userPermissions
    state.enableAssignToData = enableAssignToData
    state.companyId = companyId
    state.locationId = locationId
    state.emailId = emailId
    state.parentBaseUrl = parentBaseUrl
  },
  [MutationTypes.UPDATE_TOKEN](state: State, payload) {
    state.tokenId = payload
  },
  [MutationTypes.UPDATE_RETRY_COUNT](state: State, payload) {
    state.retryCount = payload
  },
  [MutationTypes.UPDATE_CUSTOM_VALUES](state: State, payload) {
    const { customFields, customValues, triggerLinks } = payload
    state.customFieldsLocation = customFields
    state.customValuesLocation = customValues
    state.triggerLinksLocation = triggerLinks
  },
}
